import 'jquery/dist/jquery.min.js';
import 'materialize-css/dist/js/materialize.min.js';
import { composeWithDevTools } from "redux-devtools-extension";

import { initialize, addTranslationForLanguage } from 'react-localize-redux';
/**
 * Import language files
 */
import de from './translations/german';
import en from './translations/english';
import fr from './translations/french';
import it from './translations/italian';

import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {createStore, applyMiddleware} from 'redux';
import reduxThunk from 'redux-thunk';

import './styles/App.css';

import App from './components/App';
import reducers from './reducers';
import queryString from 'query-string';

import registerServiceWorker from './registerServiceWorker';
import {setActiveLanguage} from "react-localize-redux/lib/index";

// set languages
export const languages = [
    {name: 'German', code: 'de'},
    {name: 'French', code: 'fr'},
    {name: 'English', code: 'en'},
    {name: 'Italian', code: 'it'},
];

export const store = createStore(reducers, {}, composeWithDevTools(applyMiddleware(reduxThunk)));

const values = queryString.parse(window.location.search);
// dispatch languages
store.dispatch(initialize(languages));
// add translations for all languages
store.dispatch(addTranslationForLanguage(de, 'de'));
store.dispatch(addTranslationForLanguage(en, 'en'));
store.dispatch(addTranslationForLanguage(fr, 'fr'));
store.dispatch(addTranslationForLanguage(it, 'it'));
if(values.locale) {
    store.dispatch(setActiveLanguage(values.locale));
}

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>
    , document.getElementById('root'));
registerServiceWorker();





// WEBPACK FOOTER //
// ./src/index.js